import { useContext } from 'react'

import theme from 'theme'
import Badge from 'components/common/Badge'
import Icon from 'components/Icon'
import { UpgradePanelContext } from 'components/navigation/UpgradePanelContext'
import TextButton from 'components/common/TextButton'
import ProLogo from 'components/icons/ProLogo'

export default function DashboardUpgradeBanner() {
  const { dispatch } = useContext(UpgradePanelContext)

  return (
    <div
      css={{
        background: 'linear-gradient(90deg, #009580 0%, #00458A 100%)',
        borderRadius: theme.borderRadius[0],
        marginTop: theme.space[4],
        display: 'flex',
        justifyContent: 'space-between',
        padding: theme.space[4]
      }}
      data-testid="dashboard-upgrade-banner"
    >
      <div
        css={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <ProLogo
          css={{
            width: 80
          }}
        />
        <Badge
          backgroundGradient={[theme.colors.white[0], theme.colors.white[0]]}
          css={{
            color: '#009580',
            marginLeft: theme.space[2]
          }}
        >
          PRO
        </Badge>
      </div>
      <TextButton
        as="h3"
        css={{
          display: 'flex',
          alignItems: 'center',
          letterSpacing: theme.letterSpacing[2],
          fontSize: theme.fontSizes[0],
          color: theme.colors.white[0],
          fontWeight: theme.fontWeights[1],
          '&:hover': {
            color: theme.colors.panel[0]
          }
        }}
        data-testid="dashboard-upgrade-banner-trigger"
        onClick={() =>
          dispatch({
            type: 'toggleUpgradePanel'
          })
        }
      >
        UPGRADE TO UNLOCK MORE ATTACKED TARGETS
        <Icon
          css={{
            color: theme.colors.white[0],
            fontSize: theme.fontSizes[3],
            marginLeft: theme.space[2]
          }}
          icon="chevronForward"
        />
      </TextButton>
    </div>
  )
}
